







































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
@Component({
  components: {},
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.MerchantChannelDayClearServiceProxy();
  }
  input: proxy.MerchantChannelDayClearPageInputDto =
    new proxy.MerchantChannelDayClearPageInputDto();
  sub_id = 0;
  createOrEditShow = false;
  createrange = [];
  BalanceTypes = [];
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
    },
    {
    title: "商户",
    slot: "merchantName",
    width: 200,
  },
  {
      title: "通道",
      key: "channelName",
    },
    {
      title: "创建时间",
      key: "creationTime",
    },
    {
      title: "总笔数",
      key: "totalOrderNum",
    },
    {
      title: "总金额",
      key: "totalAmount",
    },
    {
      title: "成功笔数",
      key: "successOrderNum",
    },
    {
      title: "成功金额",
      key: "successAmount",
    },
    {
    title: "商户服务费",
    key: "commission",
  },
  {
    title: "通道服务费",
    key: "channelRateCommission",
  },
    {
      title: "利润",
      key: "liRun",
    },
    {
      title: "成功率(%)",
      key: "successRate",
    },
     
  ];

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createTime = this.createrange[0];
    this.input.createTime = this.createrange[1];
    this.prox.queryModelList(this.input).then((x) => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  exportrecord() {
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    // this.prox.export(this.input).then((x) => {
    //   location.href =
    //     AppConsts.remoteServiceBaseUrl +
    //     '/File/DownloadTempFile?FileToken=' +
    //     x.fileToken +
    //     '&fileName=' +
    //     x.fileName +
    //     '&fileType=' +
    //     x.fileType;
    // });
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    this.getpage();
  }
}
